import type { FieldMetadata } from '@/sections/insights/queryBuilder/entities/types';
import { camelCaseToLabel } from '@/sections/insights/queryBuilder/entities/utils/camelCaseToLabel';
import type { Schema } from '@/types';

/**
 * Extracts WebApplication fields from backend schema
 *
 * WebApplications use the asset schema since they are Assets with class='webapplication'
 * Filters to only filterable fields and transforms camelCase keys to labels.
 *
 * @param schema - The schema object from backend
 * @returns Array of field metadata (key + label)
 *
 * @example
 * const schema = useGetSchema();
 * const fields = getWebApplicationFields(schema.data);
 */
export function getWebApplicationFields(
  schema: Schema | undefined
): FieldMetadata[] {
  if (!schema || !schema.asset) {
    return [];
  }

  // Extract filterable fields from asset schema (webapplications are assets)
  return Object.entries(schema.asset)
    .filter(([_, fieldSchema]) => fieldSchema.filterable)
    .map(([key, _]) => ({
      key,
      label: camelCaseToLabel(key),
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
